import { render } from "./PageNavigation.vue?vue&type=template&id=089f5e42&scoped=true"
import script from "./PageNavigation.vue?vue&type=script&lang=js"
export * from "./PageNavigation.vue?vue&type=script&lang=js"

import "./PageNavigation.vue?vue&type=style&index=0&id=089f5e42&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089f5e42"]])

export default __exports__